//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import payType from '@/components/pay-type/index.vue'
import moment from 'dayjs'
import couponLine from '@/components/coupon/index.vue'
import paymentSelect from '@/components/paymentSelect/index.vue'
import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
// import wxPay from "@/common/js/wxPay.js"
export default {
  // mixins: [wxPay],
  components: { paymentSelect, couponLine, uniNumberBox },
  data() {
    return {
      loading: false,
      submitLoading: false,
      isNameError: false,
      isPhoneError: false,
      detail: {},
      divHiden: false,
      countPrice: 0,
      forms: {
        number: 1,
        orderName: '', // 傅妃洛
        orderPhone: '' // 18090977964
      },
      orderId: '',
      modal: false,
      weixinBridgeInfo: {},
      hasCode: 1,
      id: '',
      t: '',
      couponCode: '',
      orderType: 'cate',
      memberId: '',
      coupons: [],
      showPaymentSelect: false,
    }
  },
  computed: {
    leftStock() {
      return this.detail.stock - this.forms.number
    },
    originalPrice() {
      return parseFloat(this.detail.settlementPrice * this.forms.number).toFixed(2)
    },
    tt() {
      return this.t + 9
    },
    price() {
      let price = parseFloat(this.detail.settlementPrice * this.forms.number - this.countPrice).toFixed(2)
      return price <= 0 ? 0.01 : price
    }
  },
  onLoad(event) {
    this.id = event.id
    this.queryData()
  },
  onShow() {
    // this.$isLogin()
    this.memberId = this.$store.state.userInfo.memberId
    if (this.memberId) {
      this.queryUserinfo()
      // this.getCoupon()
    }
  },
  methods: {
    handelClose() {
      this.close = true
      this.showPaymentSelect = false
      this.submitLoading = false
    }, testName() {
      return !!this.forms.orderName && /^[\u4e00-\u9fa5.a-zA-Z0-9]+$/.test(this.forms.orderName)
    },
    testPhone() {
      return /^1[345789]\d{9}$/.test(this.forms.orderPhone)
    },
    orderNameInput(e) {
      this.forms.orderName = e.target.value
    },
    orderPhoneInput(e) {
      this.forms.orderPhone = e.target.value
    },
    bindChange(val) {
      this.forms.number = val
    },
    hh() {
      console.log(199)
      const subNVue = uni.getSubNVueById('conpon')
      console.log(subNVue)
      subNVue.show('slide-in-bottom', 200, () => {
        console.log('subNVue 原生子窗体显示成功');
      })
    },
    submit() {
      if (this.forms.number > this.detail.stock) {
        uni.showToast({
          title: '购买数量不能大于库存！',
          icon: 'none'
        })
        return false
      }
      let _this = this
      if (this.testName() && this.testPhone()) {
        this.submitLoading = true
        //sessionStorage.getItem('memberId')
        let obj = {
          productId: this.id,
          memberId: this.memberId,
          // memberId:'599267700576878592',
          settlementPrice: this.detail.settlementPrice,
          totalPrice: this.originalPrice, // 订单总价
          payPrice: this.price,
          isDiscount: this.couponCode ? 1 : 0, // * 是否使用优惠券 * 0：否 * 1：是
          discountPrice: this.countPrice, // 优惠金额:当is_discount=1时，该字段必填
          couponCode: this.couponCode || '', // 优惠券ID
          useStartDate: this.detail.validStartDate,
          totalQuantity: this.forms.number,
          ...this.forms
        }
        this.$ajax({
          method: 'post',
          url: '/weChat/food/order/add',
          data: obj,
        }).then((res) => {
          if (res.success) {
            _this.orderId = res.data
            _this.showPaymentSelect = true
            //


            //


          }
          _this.submitLoading = false
        }).catch(() => {
          _this.submitLoading = false
        })
      } else {
        uni.showToast({
          title: '订单信息不正确',
          icon: 'none'
        })
      }
    },
    appPay() {
      if (this.forms.number > this.detail.stock) {
        uni.showToast({
          title: '购买数量不能大于库存！',
          icon: 'none'
        })
        return false
      }
      let _this = this
      if (this.testName() && this.testPhone()) {
        _this.appPayOrder()
      }
    },
    changePrice(msg) {
      this.countPrice = msg.couponDenomination || 0
      this.couponCode = msg.childCouponCode
    },
    queryUserinfo() {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/member/queryById',
        data: {
          // memberId:'599267700576878592'
          memberId: this.memberId
        }
      }).then((res) => {
        _this.forms.orderPhone = res.data.phone
        _this.forms.orderName = res.data.memberName
      })
    },
    queryData() {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/foodBody/queryByProductId',
        data: {
          productId: this.id
        },
      }).then((res) => {
        _this.detail = res.data
        _this.detail.settlementPrice = parseFloat(_this.detail.settlementPrice)
        _this.detail.validStartDate = _this.detail.validStartDate ? moment(_this.detail.validStartDate).format('YYYY-MM-DD') : ''
        _this.detail.validEndDate = _this.detail.validEndDate ? moment(_this.detail.validEndDate).format('YYYY-MM-DD') : ''
        for (let attr in _this.detail) {
          if (/Time/.test(attr)) {
            _this.detail[attr] = _this.detail[attr] ? moment(_this.detail[attr]).format('YYYY年MM月DD日') : ''
          }
        }
      })
    }
  }
}
